import { createSlice } from '@reduxjs/toolkit';
import {
  createCategory,
  fetchAllCategories,
  fetchCategoryById,
  updateCategory,
  deleteCategory
} from './expensesCategoriesAction';
import { ExpenseCategoryState } from './expensesCategoriesTypes';

const initialState: ExpenseCategoryState = {
  categories: [],
  selectedCategory: undefined,
  loadingStates: {
    create: false,
    fetchAll: false,
    fetchById: false,
    update: false,
    delete: false,
  },
  errors: {}
};

const expensesCategoriesSlice = createSlice({
  name: 'expensesCategories',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createCategory.pending, (state) => {
        state.loadingStates.create = true;
        state.errors.create = undefined;
      })
      .addCase(createCategory.fulfilled, (state, action) => {
        state.loadingStates.create = false;
        state.categories.push(action.payload.data);
      })
      .addCase(createCategory.rejected, (state, action) => {
        state.loadingStates.create = false;
        state.errors.create = action.payload as string;
      })

      // Fetch All
      .addCase(fetchAllCategories.pending, (state) => {
        state.loadingStates.fetchAll = true;
        state.errors.fetchAll = undefined;
      })
      .addCase(fetchAllCategories.fulfilled, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.categories = action.payload.data;
      })
      .addCase(fetchAllCategories.rejected, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.errors.fetchAll = action.payload as string;
      })

      // Fetch By ID
      .addCase(fetchCategoryById.pending, (state) => {
        state.loadingStates.fetchById = true;
        state.errors.fetchById = undefined;
      })
      .addCase(fetchCategoryById.fulfilled, (state, action) => {
        state.loadingStates.fetchById = false;
        state.selectedCategory = action.payload.data;
      })
      .addCase(fetchCategoryById.rejected, (state, action) => {
        state.loadingStates.fetchById = false;
        state.errors.fetchById = action.payload as string;
      })

      // Update
      .addCase(updateCategory.pending, (state) => {
        state.loadingStates.update = true;
        state.errors.update = undefined;
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
        state.loadingStates.update = false;
        const index = state.categories.findIndex(c => c.expenses_categories_id === action.payload.id);
        if (index !== -1) {
          state.categories[index] = { ...action.payload.data, expenses_categories_id: action.payload.id };
        }
      })
      .addCase(updateCategory.rejected, (state, action) => {
        state.loadingStates.update = false;
        state.errors.update = action.payload as string;
      })

      // Delete
      .addCase(deleteCategory.pending, (state) => {
        state.loadingStates.delete = true;
        state.errors.delete = undefined;
      })
      .addCase(deleteCategory.fulfilled, (state, action) => {
        state.loadingStates.delete = false;
        state.categories = state.categories.filter(c => c.expenses_categories_id !== action.payload);
      })
      .addCase(deleteCategory.rejected, (state, action) => {
        state.loadingStates.delete = false;
        state.errors.delete = action.payload as string;
      });
  }
});

export default expensesCategoriesSlice.reducer;
